function custoFabricaHistoricoM2(){
  const custos=(CACHE.custos_producao||DB.get('custos_producao')||[]).filter(c=>c.etapa!=='material');
  const total=custos.reduce((s,c)=>s+(parseFloat(c.valor)||0)+(parseFloat(c.horas)||0)*(parseFloat(c.valorHora)||0),0);
  const ids=new Set(custos.map(c=>c.pedidoId)),area=(CACHE.pedidos||[]).filter(p=>ids.has(p.id)).reduce((s,p)=>s+(parseFloat(p.area)||0),0);
  return area>0?total/area:0;
}
// Custeio por Absorção: total de despesas operacionais (exceto compra de material)
// dividido pelo total de m² produzidos no período — taxa de absorção por m²
// Aproveitamento médio ponderado real: soma(m² de peças colocadas) / soma(m² de chapa usada)
// Usa planos cortados — reflete o rendimento real da fábrica considerando que
// múltiplos pedidos compartilham a mesma chapa no plano de corte.
function aproveitamentoHistoricoFabrica(){
  var planos=(CACHE.planos_corte||DB.get('planos_corte')||[]).filter(function(p){return p.status==='cortado';});
  if(!planos.length){
    // Fallback: média simples dos rascunhos/aprovados se ainda não há cortados
    var todos=(CACHE.planos_corte||DB.get('planos_corte')||[]);
    if(todos.length){
      var somaPct=todos.reduce(function(s,p){return s+(parseFloat(p.aproveitamento)||0);},0);
      return {fator:Math.min(0.95,Math.max(0.4,somaPct/todos.length/100)),fonte:'planos_estimado',n:todos.length};
    }
    // Sem nenhum plano: usa configuração manual
    var cfg=parseFloat((CACHE.config||{}).aproveitamento)||70;
    return {fator:Math.min(0.95,Math.max(0.4,cfg/100)),fonte:'config',n:0};
  }
  // Média ponderada: m² de peças / m² de chapa consumida
  var totalPecas=0,totalChapa=0;
  planos.forEach(function(p){
    var pecasM2=parseFloat(p.totalPecasM2)||0;
    var chapaM2=(p.chapas||[]).reduce(function(s,ch){
      return s+(parseFloat(ch.largura)||0)*(parseFloat(ch.altura)||0)/10000;
    },0);
    if(chapaM2>0){totalPecas+=pecasM2;totalChapa+=chapaM2;}
  });
  if(totalChapa<=0){var cfg2=parseFloat((CACHE.config||{}).aproveitamento)||70;return {fator:cfg2/100,fonte:'config',n:0};}
  return {fator:Math.min(0.95,Math.max(0.3,totalPecas/totalChapa)),fonte:'historico_cortado',n:planos.length};
}
function custoFabricaAbsorcaoM2(meses){
  meses=meses||3;
  var d=new Date(),limite=new Date(d.getFullYear(),d.getMonth()-meses,1);
  var mesLim=limite.toISOString().slice(0,7);
  // Todas as despesas operacionais, exceto compra de material bruto
  var lancs=CACHE.lancamentos||DB.get('lancamentos')||[];
  var totalDesp=lancs.filter(function(l){
    return l.tipo==='saida'&&(l.data||'')>=mesLim&&l.cat!=='Compra de materiais';
  }).reduce(function(s,l){return s+(parseFloat(l.valor)||0);},0);
  // m² produzidos no período (pedidos que entraram em produção)
  var statusProd=['em_corte','em_acabamento','em_montagem','pronto','instalado','entregue','pos_venda','pago'];
  var peds=CACHE.pedidos||DB.get('pedidos')||[];
  var totalM2=peds.filter(function(p){
    return statusProd.includes(p.status)&&(p.data||'')>=mesLim;
  }).reduce(function(s,p){return s+(parseFloat(p.area)||0);},0);
  if(totalM2>0&&totalDesp>0) return totalDesp/totalM2;
  return custoFabricaHistoricoM2(); // fallback: apontamentos manuais
}
function calcularCompraMateriaisPorChapa(linhas,fatorAproveitamento){
  var fatorInformado=Number(fatorAproveitamento);
  var fator=Number.isFinite(fatorInformado)&&fatorInformado>0?Math.min(0.95,Math.max(0.3,fatorInformado)):1;
  var grupos=new Map();
  (Array.isArray(linhas)?linhas:[]).forEach(function(linha){
    var nome=String(linha.nome||'Material não informado').trim()||'Material não informado';
    var espessura=String(linha.espessura||'').trim();
    var chave=String(linha.chave||nome).trim().toLowerCase()+'|'+espessura.toLowerCase();
    if(!grupos.has(chave))grupos.set(chave,{chave:chave,nome:nome,espessura:espessura,areaLiquidaM2:0,materialAdicional:0,areaChapaM2:0,precoM2:0,precoChapaFinal:0,fontePreco:linha.fontePreco||''});
    var grupo=grupos.get(chave);
    grupo.areaLiquidaM2+=Math.max(0,Number(linha.areaM2)||0);
    grupo.materialAdicional+=Math.max(0,Number(linha.materialAdicional)||0);
    if(Number(linha.areaChapaM2)>0)grupo.areaChapaM2=Number(linha.areaChapaM2);
    if(Number(linha.precoM2)>0)grupo.precoM2=Number(linha.precoM2);
    if(Number(linha.precoChapaFinal)>0){grupo.precoChapaFinal=Number(linha.precoChapaFinal);grupo.fontePreco='chapa_final';}
    else if(!grupo.fontePreco&&linha.fontePreco)grupo.fontePreco=linha.fontePreco;
  });
  var detalhes=[...grupos.values()].map(function(grupo){
    var precoChapaAplicado=grupo.precoChapaFinal>0?grupo.precoChapaFinal:grupo.areaChapaM2*grupo.precoM2;
    var precoM2Equivalente=grupo.precoChapaFinal>0&&grupo.areaChapaM2>0?grupo.precoChapaFinal/grupo.areaChapaM2:grupo.precoM2;
    var areaAdicionalEquivalente=precoM2Equivalente>0?grupo.materialAdicional/precoM2Equivalente:0;
    var areaCusteioM2=grupo.areaLiquidaM2+areaAdicionalEquivalente;
    var areaBrutaM2=areaCusteioM2/fator;
    if(grupo.areaChapaM2>0&&precoChapaAplicado>0){
      var chapasFracionadas=areaBrutaM2/grupo.areaChapaM2;
      var chapasInteiras=areaBrutaM2>0?Math.ceil(chapasFracionadas-1e-9):0;
      var areaCompraM2=chapasInteiras*grupo.areaChapaM2;
      var custo=Math.round(chapasInteiras*precoChapaAplicado*100)/100;
      return{...grupo,modo:'chapa_inteira',fatorAproveitamento:fator,areaAdicionalEquivalente:areaAdicionalEquivalente,areaCusteioM2:areaCusteioM2,areaBrutaM2:areaBrutaM2,chapasFracionadas:chapasFracionadas,chapasInteiras:chapasInteiras,areaCompraM2:areaCompraM2,sobraEstimadaM2:Math.max(0,areaCompraM2-areaCusteioM2),precoChapaAplicado:precoChapaAplicado,fontePreco:grupo.precoChapaFinal>0?'chapa_final':'m2_derivado',custo:custo};
    }
    var custoLegado=Math.round(((grupo.areaLiquidaM2*grupo.precoM2)+grupo.materialAdicional)/fator*100)/100;
    return{...grupo,modo:'m2_estimado',fatorAproveitamento:fator,areaAdicionalEquivalente:areaAdicionalEquivalente,areaCusteioM2:areaCusteioM2,areaBrutaM2:areaBrutaM2,chapasFracionadas:0,chapasInteiras:0,areaCompraM2:0,sobraEstimadaM2:0,precoChapaAplicado:0,custo:custoLegado};
  });
  return{fatorAproveitamento:fator,detalhes:detalhes,total:Math.round(detalhes.reduce(function(s,detalhe){return s+detalhe.custo;},0)*100)/100};
}
